import { useState, useEffect } from 'react';
import {
  fetchIndustryOptions,
  fetchHealthScoreOptions,
  fetchCountryOptions,
  fetchZoneOptions,
  fetchPartnerOptions,
} from '../services/dynamicsApi';

export const useSearchOptions = (accessToken, t) => {
  const [industries, setIndustries] = useState([]);
  const [healthScoreOptions, setHealthScoreOptions] = useState([]);
  const [countries, setCountries] = useState([]);
  const [zones, setZones] = useState([]);
  const [partners, setPartners] = useState([]);
  const [loadingOptions, setLoadingOptions] = useState(false);
  const [loadError, setLoadError] = useState(null);

  useEffect(() => {
    const loadOptions = async () => {
      if (!accessToken) return;

      setLoadingOptions(true);
      setLoadError(null);
      try {
        const [industryOpts, healthScoreOpts, countryOpts, zoneOpts, partnerOpts] = await Promise.all([
          fetchIndustryOptions(accessToken),
          fetchHealthScoreOptions(accessToken),
          fetchCountryOptions(accessToken),
          fetchZoneOptions(accessToken),
          fetchPartnerOptions(accessToken),
        ]);
        setIndustries(industryOpts);
        setHealthScoreOptions(healthScoreOpts);
        setCountries(countryOpts);
        setZones(zoneOpts);
        setPartners(partnerOpts);
      } catch (error) {
        console.error('Error loading search options:', error);
        setLoadError(t ? t('sf_loadError') : 'Error loading options');
      } finally {
        setLoadingOptions(false);
      }
    };

    loadOptions();
  }, [accessToken, t]);

  return {
    industries,
    healthScoreOptions,
    countries,
    zones,
    partners,
    loadingOptions,
    loadError
  };
};
